import { Button } from '@design-system/components';
import { TRegionKey } from '@source/interface';
import { Divider } from 'antd';
import styled from 'styled-components';

export const StyledHeadingMobile = styled.h3`
  margin: 0;
  font-size: 20px;
  line-height: 28px;
  color: ${(props) => props.theme.color.onPrimary};
  ${(props) => props.theme.typo.familyGoogle.regular};
  > span {
    &:first-child {
      font-weight: 600;
    }
    &:last-child {
      font-weight: 400;
    }
  }
`;
export const StyledWrapper = styled.div`
  ${(props) => props.theme.typo.familyGoogle.regular}
  margin-top: auto;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    opacity: 1;
    background: ${(props) => props.theme.color.primaryBase};
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    z-index: -1;
  }
  @media (min-width: 576px) {
    width: calc(100% - 16px - 16px);
  }
  @media (min-width: 992px) {
    width: calc(100% - 48px - 48px);
  }
  @media (min-width: 1280px) {
    width: 1184px;
  }
`;
export const StyledCertified = styled.div`
  width: calc(100vw - 16px - 16px);
  height: 78px;
  padding: 0 16px;
  overflow: hidden;
  -webkit-transition: height 1s ease;
  transition: height 1s ease;
  margin-bottom: 8px;

  &.extend-height {
    height: auto;
  }

  .item-title {
    color: ${(props) => props.theme.color.onPrimary};
  }
  .see-more-btn {
    position: absolute;
    bottom: 0;
    right: 0;
    min-width: 95px;
    background: #ffa680;
    border-radius: 9px 0px 0px 0px;
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;
    padding: 6px 12px;
    border: none;
  }
`;

export const StyledList = styled.div`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-weight: 500;

  > li {
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${(props) => props.theme.color.onPrimary};
    font-size: 12px;
    line-height: 14px;
    &:last-child {
      max-width: 75%;
    }
  }

  .break-mb {
    display: block;
  }
`;

export const StyledButton = styled(Button)`
  height: unset;
  position: absolute;
  bottom: 0;
  right: 0;
  min-width: 95px;
  background: #ffa680;
  border-radius: 9px 0px 0px 0px;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  padding: 6px 12px;
  gap: 4px;

  .see-less-icon {
    transform: rotate(180deg) scaleX(-1);
  }
`;

export const StyledDividerTitle = styled(Divider)`
  &.ant-divider-horizontal.ant-divider-with-text {
    border-color: #fff;
    margin: 8px 0;
  }

  .ant-divider-inner-text > span {
    color: ${(props) => props.theme.color.onPrimary};
  }
`;

export const StyledDesktopWrapper = styled.div<{ country: TRegionKey; isMS: boolean; isV2: boolean }>`
  width: 100%;
  height: 118px;
  display: flex;
  align-items: center;
  color: #fff;

  padding: 11px 48px 12px;

  .item-wrapper {
    width: 100%;
    height: 100%;

    display: inline-flex;
    height: 92px;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    flex-shrink: 0;
    text-align: center;
    color: #fff;

    .item-title {
      // flex: 1 1 0px;
      color: #fff;
      font-family: ${(props) => props.theme.fontFamily};
      font-size: 17px;
      line-height: 17px;
      letter-spacing: -0.4px;
      text-align: left;
      padding-left: 14px;
      padding-right: 9px;
      text-align: left;
      > span:first-child {
        font-weight: 600;
      }
      > span:last-child {
        font-weight: 400;
      }
    }

    .item-title-my {
      padding-left: 0;
      padding-right: 0;
    }

    .item {
      font-size: 10px;
      line-height: 12px;
      font-family: ${(props) => props.theme.fontFamilySemibold};
      font-weight: 400;
      letter-spacing: -0.2px;
      height: 100%;
      display: flex;
      align-items: center;
      /* justify-content: center; */
      position: relative;
      flex-direction: column;
      justify-content: flex-start;
      // flex: 1 1 0px;

      /* &:nth-child(even) {
        border-left: 1px solid #ffffff;
        border-right: 1px solid #ffffff;
      } */

      &:last-child {
        border-right: 0;
      }

      .item-icon {
        margin-bottom: 8px;
        max-width: 36px;
      }
    }
  }

  .ant-divider {
    height: 92px;
    border-left: 1px solid #fff;
    margin: 0;
    top: 0;
  }

  @media screen and (min-width: 768px) {
    height: 118px;

    .item-wrapper {
      gap: 12px;
      height: 94px;

      .item-title {
        font-size: 36px;
        line-height: 36px;
        letter-spacing: -0.5px;
      }

      .item {
        font-size: 11px;
        line-height: 14px;
        letter-spacing: -0.25px;

        .item-icon {
          max-width: 56px;
        }

        .item-content {
          white-space: ${(props) => (props.country === 'jp' ? 'unset' : 'nowrap')};
        }
      }
    }
  }

  @media screen and (min-width: 992px) {
    .item-wrapper {
      .item {
        .item-content {
          white-space: nowrap;
        }
      }
    }
  }

  @media screen and (min-width: 1280px) {
    height: 133px;

    .item-wrapper {
      gap: 19px;

      .item-title {
        font-size: 36px;
        line-height: 36px;
      }

      .item {
        font-size: ${(props) => ((props.country === 'sg' && props.isMS) || props.isV2 ? '11px' : '14px')};
        line-height: 140%;

        .item-icon {
          max-width: 56px;
        }

        .item-content {
          text-wrap: nowrap;
        }
      }
    }
  }
`;
